import { FC, memo, useCallback } from 'react';
import { TabProps, TabThemes } from '../TypeProps';
import classNames from 'classnames';

import styles from './Tab.module.scss';

export const Tab: FC<TabProps> = memo(function Tab({ className, active, title, index, quantity, themes = TabThemes.Primary, handler }) {
  const handlerClick = useCallback(() => {
    handler(index);
  }, [index, handler]);
  return (
    <div
      className={classNames(styles.WrapperTab, styles[themes], { [styles.active]: active }, className)}
      onClick={handlerClick}
      data-testid={`tab-${index}`}
    >
      {title}
      {!!quantity && <span className={styles.Quantity}>{quantity}</span>}
    </div>
  );
});
